<template>
  <v-app id="login" class="secondary">
    <v-main>
      <v-dialog
        v-model="dialogRegister"
        width="700">
        <v-card>
          <v-card-title class="headline"
                        primary-title>
            Set Up
          </v-card-title>

          <v-card-text>
            <v-form>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 xs6 md11>
                    <v-text-field
                      v-model="setup_user.firstname"
                      label="First name"
                      :rules="[rules.required]"
                      hint="Set user first name"/>
                  </v-flex>
                  <v-flex xs12 xs6 md11>
                    <v-text-field
                      v-model="setup_user.lastname"
                      :rules="[rules.required]"
                      label="Last name"
                      hint="Set user last name"/>
                  </v-flex>
                  <v-flex xs12 xs6 md11>
                    <v-text-field
                      v-model="setup_user.skype"
                      :rules="[rules.required]"
                      label="User Skype"
                      hint="Set user skype"/>
                  </v-flex>
                  <v-flex xs12 xs6 md11>
                    <v-text-field
                      v-model="setup_user.useremail"
                      :rules="[rules.required]"
                      label="User Email"
                      hint="Set user email"/>
                  </v-flex>

                  <v-flex xs12 xs6 md1/>

                  <v-flex xs12 sm6 md11>
                    <v-text-field
                      v-model="setup_user.password"
                      :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                      :type="showPassword ? 'text' : 'password'"
                      label="New Password"
                      hint="Please choose a complex one.."
                      :error="error"
                      @click:append="showPassword = !showPassword"/>
                  </v-flex>

                  <v-flex xs12 sm6 md1/>

                  <v-flex xs12 sm6 md11>
                    <v-text-field
                      v-model="setup_user.passwordConfirm"
                      :append-icon="showPasswordConfirm ? 'visibility_off' : 'visibility'"
                      :type="showPasswordConfirm ? 'text' : 'password'"
                      label="Confirm New Password"
                      hint="and confirm it."
                      :error="error"
                      @click:append="showPasswordConfirm = !showPasswordConfirm"/>
                  </v-flex>

                  <v-flex xs12 sm6 md1/>
                  <v-flex xs12 xs6 md1/>

                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialogRegister = !dialogRegister">cancel</v-btn>
            <v-btn color="primary" @click="register">Set UP</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="static/logo1.png" alt="Stratis Inventory" width="180" height="180">
                  <h1 class="flex my-4 primary--text">Stratis Inventory</h1>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="useremail"
                    :error="error"
                    :rules="[rules.required]"/>
                  <v-text-field
                    :type="hidePassword ? 'password' : 'text'"
                    :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                    name="password"
                    label="Password"
                    id="password"
                    :rules="[rules.required]"
                    v-model="password"
                    :error="error"
                    @click:append="hidePassword = !hidePassword"/>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block rounded="true" color="primary" @click="login" :loading="loading">Login</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn block rounded="true" color="primary" @click="dialogRegister = !dialogRegister" :loading="loading">Register</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar
        v-model="showResult"
        :timeout="5000"
        top>
        {{ result }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      dialogRegister: false,
      setup_user: {},
      loading: false,
      useremail: '',
      showPassword: null,
      showPasswordConfirm: null,
      password: '',
      hidePassword: true,
      error: false,
      showResult: false,
      result: '',
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },

  methods: {
    login() {
      const vm = this;
      const lp = {
        useremail: vm.useremail,
        password: vm.password
      }

      if (!vm.useremail || !vm.password) {
        vm.result = "Email and Password can't be null.";
        vm.showResult = true;
        return;
      } else {
        // console.log(lp);
        this.$http
          .post(this.$root.apiUrl + '/api/v1/user/login', lp)
          .then(r => {
              // console.log('r: ', JSON.stringify(r, null, 2));

              if (!r.data.token) {
                vm.error = true;
                vm.result = "Email or Password is incorrect.";
                vm.showResult = true;
              } else {
                localStorage["access_token"] = r.data.token;
                localStorage["profile"] = JSON.stringify(r.data.profile);
                this.$router.push({name: 'Dashboard'})
              }
            }
          );
      }
    },


    register() {
      const vm = this.setup_user;
      const vm1 = this;
      if (vm.userEmail === null || vm.password === null || vm.passwordConfirm === null) {

        vm1.result = "Email and Password can't be null.";
        vm1.showResult = true;

        return;
      }

      if (vm.firstname === null || vm.lastname === null || vm.skype === null) {

        vm1.result = "need First Name Last Name skype";
        vm1.showResult = true;

        return;
      }

      if (vm.password !== vm.passwordConfirm) {

        vm1.error = true;
        vm1.result = "Passwords does not match the confirm password.";
        vm1.showResult = true;

        return;
      }

      if (vm.firstName != null || vm.lastName != null || vm.skype != null || vm.email != null || vm.password != null) {
        this.$http
          .post(Vue.prototype.$api_url + '/api/v1/user/register', vm)
          .then(r => {
            // console.log('r: ', JSON.stringify(r, null, 2));
            if (r.status === 201) {
              localStorage["access_token"] = r.data.token;
              localStorage["profile"] = JSON.stringify(r.data.profile[0]);
              this.$router.push({name: 'Dashboard'})
            } else {
              vm1.error = true;
              vm1.result = "User already exists.";
              vm1.showResult = true;
            }

          });


      }


    }
  }
}
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/core/Login.vue